import { render, staticRenderFns } from "./CreateCategoriesBlock.vue?vue&type=template&id=7a327224&scoped=true&"
import script from "./CreateCategoriesBlock.vue?vue&type=script&lang=js&"
export * from "./CreateCategoriesBlock.vue?vue&type=script&lang=js&"
import style0 from "./CreateCategoriesBlock.vue?vue&type=style&index=0&id=7a327224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a327224",
  null
  
)

export default component.exports